import { ChangeDetectorRef, Component, inject, NgZone, OnInit, signal, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { GoogleMapsLoaderService } from '../../../../../core/services/google-maps-loader.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { DefaultConstant } from '../../../../../constants/enum/common/default.enum';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { DateUtil } from '../../../../../core/utils/date-util';

@Component({
  standalone: false,
  selector: 'kt-start-break',
  templateUrl: './start-break.component.html',
  styleUrls: ['./start-break.component.scss'],
})
export class StartBreakComponent implements OnInit {
  isSaveButtonDisplay = true;
  breaks: any = [];
  buttonConfig = BUTTON_CONFIG;
  location: any = {};
  shiftDetails: any = null;
  distanceFromActualLocation = 0;
  breakFormGroup = new UntypedFormGroup({ break: new UntypedFormControl() });
  mapReady = signal(false);
  infoContent = '';
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  private readonly mapsLoader = inject(GoogleMapsLoaderService);
  constructor(public activeModal: NgbActiveModal, private ngZone: NgZone, private cdr: ChangeDetectorRef) { }
  defaultEnum = DefaultConstant;
  isUnscheduled = false;
  openInfoWindow(marker: MapMarker, content: string) {
    this.infoContent = content;
    if (this.infoWindow) {
      this.infoWindow.open(marker);
    }
  }
  ngOnInit() {
    this.mapsLoader.load().then(() => this.mapReady.set(true));
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.ngZone.run(() => {
          this.location.latitude = position.coords.latitude;
          this.location.longitude = position.coords.longitude;
          this.distanceFromActualLocation = CommonUtil.distance(this.location.latitude, this.location.longitude, (+this.shiftDetails.area.area_latitude), (+this.shiftDetails.area.area_longitude), 'K');
          this.cdr.detectChanges();
        });
      });
    }
    let minTime = Number.POSITIVE_INFINITY;
    let minBreak = null;
    let count = 0;

    this.breaks.forEach(breakDetail => {
      if (breakDetail.shift_break_fix_time_enable) {
        const now = DateUtil.getCurrentDateTimeWithLocationTimezone(this.shiftDetails.location.location_fk_timezone_name);
        const breakTime = moment(DateUtil.convertDateToUtcWithLocationTimezone(breakDetail.shift_break_start_date, this.shiftDetails.location.location_fk_timezone_name));
        const difference = moment.duration(now.diff(breakTime)).minutes()
        const diff = Math.abs(difference);
        
        if (diff < minTime) {
          minTime = diff;
          minBreak = breakDetail;
        }

        if (breakDetail.shift_break_start_date && moment.duration(moment.tz(breakDetail.shift_break_start_date, this.shiftDetails.location.location_fk_timezone_name).diff(moment().tz(this.shiftDetails.location.location_fk_timezone_name))).asMinutes() > 5) {
          count = count + 1;
          breakDetail.disabled = true;
          if (minBreak === breakDetail) {
            minBreak = null;
          }
        }
      }
    });

    if (count === this.breaks.length) {
      this.isSaveButtonDisplay = false;
    }

    if (minBreak) {
      this.breakFormGroup.get('break').setValue(minBreak);
    } else {
      if (this.breaks && this.breaks.length && this.breaks[0]) {
        this.breakFormGroup.get('break').setValue(this.breaks[0]);
      }
    }
  }

  startBreakHandler() {
    this.activeModal.close(this.breakFormGroup.value);
  }

}
